<div class="detalhe-item">
  <p-tabs [value]="0">
    <p-tablist>
      <p-tab [value]="0">
        <span class="p-tabview-title">
          <span class="round-counter" [ngClass]="{ 'round-counter-empty': !data?.motivos_rejeicao_item?.length }">{{
            data?.motivos_rejeicao_item?.length ?? 0
          }}</span>
          Motivos de rejeição do Item
        </span>
      </p-tab>
    </p-tablist>
    <p-tabpanels>
    <p-tabpanel [value]="0">
      <ag-grid-angular
        #agGridMotivosRejeicao
        class="ag-theme-balham w-full"
        style="height: 200px"
        [rowData]="data?.motivos_rejeicao_item"
        [gridOptions]="gridOptionsMotivosRejeicao"
      >
      </ag-grid-angular>
    </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
